export default {
  get: state => state.agreedToPrivacy,
  getConfig: state => state.config,
  getSnackbar: state => state.snackbar
};
